var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 -0.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_02.twitter",
    "data-name": "02.twitter",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "background",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(0 0.47)",
    fill: "#00a6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M60.193,46.923a9.389,9.389,0,0,1-1.9,2.092A.813.813,0,0,0,58,49.65v.073a13.335,13.335,0,0,1-.86,4.64A13.59,13.59,0,0,1,54.6,58.605a12.5,12.5,0,0,1-5.486,3.625,13.721,13.721,0,0,1-4.312.67A13.164,13.164,0,0,1,38.2,61.119a.38.38,0,0,1-.183-.422.366.366,0,0,1,.357-.275h.556a8.847,8.847,0,0,0,4.956-1.5,4.8,4.8,0,0,1-3.8-3.265.252.252,0,0,1,.293-.325,4.412,4.412,0,0,0,.807.076h.1a4.807,4.807,0,0,1-2.8-4.421.252.252,0,0,1,.372-.219,4.225,4.225,0,0,0,1.094.424,4.8,4.8,0,0,1-.775-5.828.252.252,0,0,1,.413-.035,12.56,12.56,0,0,0,8.634,4.617h.023a.181.181,0,0,0,.176-.2,5.079,5.079,0,0,1,.111-1.755,4.655,4.655,0,0,1,3.13-3.347,5.146,5.146,0,0,1,1.518-.234,4.786,4.786,0,0,1,3.171,1.2.62.62,0,0,0,.413.158.629.629,0,0,0,.146-.02,8.777,8.777,0,0,0,2.341-.968.249.249,0,0,1,.366.293,4.748,4.748,0,0,1-1.261,2.01,8.836,8.836,0,0,0,1.533-.518.252.252,0,0,1,.307.363Z",
    transform: "translate(-26.884 -31.417)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e16959ae5998af0b92b932edfa49c627.svg";
export { ForwardRef as ReactComponent };